import { graphql } from "gql";

const CREATE_JOB_MUTATION = graphql(`
  mutation CreateJob(
    $messageThreadId: ID!
    $type: JobType!
    $attachFileToIntegrationInput: AttachFileToIntegrationInput
  ) {
    createJob(
      input: {
        messageThreadId: $messageThreadId
        type: $type
        attachFileToIntegrationInput: $attachFileToIntegrationInput
      }
    ) {
      id
      type
      status
    }
  }
`);

export default CREATE_JOB_MUTATION;
